import leovegasAccountImage from "../assets/leovegas/faq/account.svg"
import leovegasfriendsImage from "../assets/leovegas/faq/friends.svg"
import leovegasPaymentImage from "../assets/leovegas/faq/payment.svg"
import leovegasSearchIcon from "../assets/leovegas/icon-search.svg"

const palette = {
  gold: "#b19661",
  black: "#0a0a0a",
  white: "#fff"
}

export const themes = {
  betmgm: {
    colours: {
      main: palette.gold,
      black: "#0a0a0a",
      darkGrey: "#303030",
      white: "#fff",
      title: "#fff"
    },
    fonts: {
      primary: `GTAmerica-Condensed, sans-serif`
    },
    fontsUrl: "",
    button: {
      medium: {
        fontSize: "0.75em"
      },
      large: {
        fontSize: "16px"
      }
    },
    padding: {
      squashedPadding: "15px"
    },
    sizes: {
      navigation: {
        mobile: 846
      },
      header: {
        mobile: 846
      },
      footer: {
        large: 1440,
        medium: 1024,
        mobile: 846
      },
      about: {
        mobile: 846
      },
      faq: {
        small: 650,
        medium: 750,
        large: 850
      },
      aboutCollapse: 800
    },
    footer: {
      bgColor: palette.black
    },
    homepageBrands: {
      bgColor: palette.black
    },
    registerContainer: {
      bgColor: palette.black
    },
    news: {
      linkPreview: palette.gold,
      previewInfoBg: palette.black
    },
    cookieConsent: {
      disclaimer: {
        fontSize: "1em",
        colour: "#000",
        link: {
          colour: "#008c70"
        }
      },
      bgColour: "#fff",
      borderColour: "#e0e0e0",
      cookieIcon: {
        bgColour: "#f1f0ec",
        colour: "#000"
      },
      toggles: {
        track: {
          offColour: "#b6b6b6",
          onColour: "#e8e0d0"
        },
        pin: {
          offColour: "#e2e2e2",
          onColour: palette.gold
        },
        labelColour: "#000",
        descriptionColour: "#c0c0c0"
      },
      buttons: {
        fontSize: "1em",
        textTransform: "uppercase",
        allowAll: {
          colour: "#000",
          bgColour: palette.gold,
          borderRadius: "32px",
          padding: "0 32px",
          maxHeight: "48px",
          boxShadow: "rgba(0, 0, 0, 0.25) 0px 5px 5px -3px",
          width: "max-content",
          hover: {
            bgColour: "#c6b38c"
          }
        },
        manage: {
          colour: palette.gold,
          bgColour: "transparent",
          hover: {
            bgColour: "#c8b69061"
          },
          borderRadius: "32px",
          padding: "0 14px",
          maxHeight: "48px"
        },
        confirm: {
          colour: "#000",
          bgColour: palette.gold,
          borderRadius: "32px",
          padding: "0 32px",
          maxHeight: "48px",
          boxShadow: "rgba(0, 0, 0, 0.25) 0px 5px 5px -3px",
          hover: {
            bgColour: "#c6b38c"
          }
        }
      }
    },
    faq: {
      icons: {
        searchIcon: leovegasSearchIcon,
        accountImage: leovegasAccountImage,
        friendsImage: leovegasfriendsImage,
        paymentImage: leovegasPaymentImage
      }
    },
    testimonials: {
      bgPageColour: "#fff",
      headerBgColour: "#fff",
      headerTextColour: "#fff",
      nameColour: "#000",
      nameBackground: palette.gold,
      textColour: "#094664",
      urlColour: "#1480B8"
    }
  }
}
